import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import UserModal from "./userinfo";
import TextField from "@mui/material/TextField";
import { setLocation } from "../../Redux/mainActions";
import { connect } from "react-redux";
import { Typography, Autocomplete, Box, Popper } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
const Main = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  direction: rtl;
  padding: 3px 20px;
`;
const P = styled.p`
  font-family: SansX;
  color: #5c5c5c;
  font-weight: 600;
`;
function Navbar(props) {
  const { Button, Detatil } = props;
  const [options, setOptions] = useState([]);
  const [name, setName] = useState(null);
  const previousController = useRef();

  const getData = (searchTerm) => {
    if (previousController.current) {
      previousController.current.abort();
    }
    const controller = new AbortController();
    const signal = controller.signal;
    previousController.current = controller;
    fetch(
      `http://goharbaar.ir/api/neshan/search?term=${searchTerm}&&lat=1&&lng=1`,
      {
        signal,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem(
            "token" || "ref_token"
          )}`,
        },
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (myJson) {
        const updatedOptions = myJson?.data?.response.items.map((p) => {
          return p;
        });
        setOptions(updatedOptions);
      });
      
  };
  const onInputChange = (event, value, reason) => {
    if (value && value.length >1) {
      getData(value);
    } else {
      setOptions([]);
    }
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  useEffect(() => {
    if (props.value) {
      
      props.setAddress(name?.location);
    }
  }, [name]);
  return (
    <Main>
      <div style={{display:'flex' ,flexDirection:'row' ,justifyContent:'space-between' ,width:'100vw'}}>
      {window.location.pathname !== '/dashboard' ?
            <IconButton href='dashboard'>
                <ArrowBack  />
            </IconButton>
             :<IconButton href={Button}>
             <AddIcon  />
         </IconButton>}
      
      {/* <MenuIcon /> */}
      <P>{Detatil}</P>
      <UserModal open={open} handleOpen={handleOpen} handleClose={handleClose} />
      </div>
      {props.value ? 
      <Autocomplete
        id="combo-box-demo"
        noOptionsText='نتیجه ای وجود ندارد.'
        filterOptions={x => x}
        options={options}
        onInputChange={onInputChange}
        onChange={(e, value) => setName(value)}
        getOptionLabel={(option) => option.title}
        style={{ width: "100%" }}
        renderInput={(params) => (
          <TextField {...params} label="جستجو" variant="standard" />
        )}
      />:null}
    </Main>
  );
}
const mapStateToProps = (state) => {
  return {
    location: state.location,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLocation: (value) => dispatch(setLocation(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
